import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AuthState, checkAuth, updateAccessToken, selectAuthState } from '@emi/shared/state/auth';
import { MenuItem } from '@emi/shared/models';
import * as Constants from '@emi/shared/constants';

@Component({
    selector: 'via-ui-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    public isAuthenticated = false;

    public menuItems: Array<MenuItem> = [
        {
            name: 'My Downloads',
            url: `/${Constants.Routes.EXTRACT_APP_URL}/#/${Constants.Routes.ACCOUNT_ROUTE}/${Constants.Routes.DOWNLOADS_ROUTE}`,
            redirect: true
        }
    ];

    constructor(private store: Store<AuthState>) {}

    public ngOnInit(): void {
        this.store.dispatch(checkAuth());
        this.store.pipe(select(selectAuthState)).subscribe((x) => (this.isAuthenticated = x.loginResponse.isAuthenticated));

        setInterval(
            () => this.store.dispatch(updateAccessToken()),
            Constants.GlobalVariables.UPDATE_ACCESS_TOKEN_STATE_INTERVAL_MILLISECONDS
        );
    }
}
